module.exports = __webpack_public_path__ + "d904244237c492397256e0ed109c53a1.svg";